export default __webpack_public_path__ + "static/media/huaiyang-2-1point5-768x514.cf79d99d.jpg";